import useSwr from "@/core/composables/swr/useSwr";
import {programApi} from "@/container";
import {IConfig} from "swrv";


/**
 * Composable to fetch support program settings.
 */
const useSupportProgramSettings = (supportProgramId: number, options: IConfig = {}) => {
    const {data, isLoading, mutate} = useSwr(
        `/support_programs/${supportProgramId}/settings`,
        () => programApi().supportProgramSettings(supportProgramId),
        options
    );

    /**
     * Update a group setting.
     * @param group The group slug to update.
     * @param enabled Whether the group notification is enabled.
     */
    const updateGroup = async (group: string, enabled: boolean) => {
        if(!data.value) return;

        const updated = await programApi().updateSupportProgramSettings(data.value.id, {
            groups: [{ group, enabled }]
        });

        await mutate(() => updated);
    };

    return {
        data,
        isLoading,
        mutate,
        updateGroup,
    };
};

export default useSupportProgramSettings;
